export default __webpack_public_path__ + "static/media/3_Still.d3649e71.jpg";